import { call, put, takeEvery } from "redux-saga/effects";
import { setError } from "store/error/slice";
import axiosInstance from "clients/api";
import { callCanvaDesignAddPromise, CANVA_DESIGNS_CALL, callCanvaDesignsByIdPromise } from "./sagas-actions";
import { onCallCanvaDesigns, onFailedCanvaDesigns, onSuccessCanvaDesigns } from "./slice";
import qs from "qs";
import { implementPromiseAction, resolvePromiseAction } from "@adobe/redux-saga-promise";

function* canvaDesignsCallGenerator(action) {
  try {
    const {
      payload: { page, withoutLoading }
    } = action;

    if (!withoutLoading) {
      yield put(onCallCanvaDesigns());
    }

    const params = {
      current_page: page,
      page_size: 10,
      search: ""
    };

    const queryString = qs.stringify(params);

    const { data } = yield call(axiosInstance.get, `/base/canva_get_list?${queryString}`);
    yield put(onSuccessCanvaDesigns({ data, page }));
  } catch (error) {
    yield put(
      setError({
        error,
        action
      })
    );
    yield put(onFailedCanvaDesigns());
  }
}

function* canvaDesignAddCallPromiseGenerator(action) {
  yield call(implementPromiseAction, action, function* canvaAddWorker() {
    try {
      const { data } = yield call(axiosInstance.post, "/base/canva_add");
      return data;
    } catch (error) {
      yield put(
        setError({
          error,
          action
        })
      );
    }
  });
}

function* canvaDesignsByIdCallPromiseGenerator(action) {
  yield call(implementPromiseAction, action, function* canvaAddWorker() {
    try {
      const {
        payload: { ids }
      } = action;
      const { data } = yield call(axiosInstance.post, "/base/canva_get_by_ids", {
        ids
      });
      yield call(resolvePromiseAction, action, data);
    } catch (error) {
      yield put(
        setError({
          error,
          action
        })
      );
    }
  });
}

export default function* exportSaga() {
  yield takeEvery(CANVA_DESIGNS_CALL, canvaDesignsCallGenerator);
  yield takeEvery(callCanvaDesignAddPromise, canvaDesignAddCallPromiseGenerator);
  yield takeEvery(callCanvaDesignsByIdPromise, canvaDesignsByIdCallPromiseGenerator);
}
